import React from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Modal from "../components/Modal"
import Selecao from "../components/Selecao"

const ModalSelecaoLaboratorio = ({
    modalAberto,
    setModalAberto,
    opcoesLaboratorios,
    laboratorio,
    setLaboratorio,
    handleClickBotaoModal,
    carregandoModal }) => {

    const classes = useStyles()

    const handleFecharModal = () => {
        setModalAberto(false)
    }

    return (
        <Modal
            modalAberto={modalAberto}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            titulo={"Selecione o laboratório para cadastro e acompanhamento de amostras"}
            maxWidth={"xs"}
            fecharModal={handleFecharModal}
            botaoPrincipal={{
                texto: "Ir para visão do laboratório",
                acao: () => handleClickBotaoModal(),
                desabilitado: !laboratorio.codigo,
                carregando: carregandoModal
            }}
            className={classes.modalSelecaoLaboratorio}
        >
            <Grid container className={"pr-2 pl-2 pt-2 pb-5"}>
                <Grid className={classes.gridSelecao} item xs={12}>
                    <Selecao
                        etiqueta="Selecione o laboratório"
                        id="SelecaoLaboratorio"
                        opcoes={opcoesLaboratorios}
                        modal={true}
                        codigo={laboratorio.codigo}
                        retornarObjetoCompleto={true}
                        handleChange={(_, value) => {
                            setLaboratorio(value)
                        }}
                    />
                </Grid>
            </Grid>
        </Modal>
    )
}

const useStyles = makeStyles((theme) => ({
    modalSelecaoLaboratorio: {},
}))

export default ModalSelecaoLaboratorio